import React from 'react'
import UserHeader from './UserHeader'
import UserFooter from './UserFooter'

function Index15() {
  return (
    <div>
        <UserHeader/>
        <main className="main">
  <div className="intro-slider-container">
    <div className="intro-slider owl-carousel owl-simple owl-nav-inside owl-light" data-toggle="owl" data-owl-options="{&quot;nav&quot;:false, &quot;dots&quot;: false, &quot;loop&quot;: false}">
      <div className="intro-slide" style={{backgroundImage: 'url(asset/images/demos/demo-15/slider/slide-1.jpg)'}}>
        <div className="container intro-content text-center">
          <h3 className="intro-subtitle">Want to know what's hot?</h3>{/* End .h3 intro-subtitle */}
          <h1 className="intro-title text-white">Spring Lookbook 2019</h1>{/* End .intro-title */}
          <a href="#scroll-to-content" className="btn btn-outline-primary-2 scroll-to">
            <span>Start scrolling</span>
            <i className="icon-long-arrow-down" />
          </a>
        </div>{/* End .intro-content */}
      </div>{/* End .intro-slide */}
    </div>{/* End .intro-slider owl-carousel owl-simple */}
    <span className="slider-loader text-white" />{/* End .slider-loader */}
  </div>{/* End .intro-slider-container */}
  <div className="display-row" id="scroll-to-content">
    <div className="container-fluid">
      <div className="row align-items-center">
        <div className="col-lg-6 order-lg-last">
          <div className="banner banner-overlay">
            <a href="#">
              <img src="asset/images/demos/demo-15/banners/banner-1.jpg" alt="Banner" />
            </a>
            <div className="banner-content men">
              <h2 className="banner-title text-white">01. Get your <br />inspiration <br />in the street.</h2>{/* End .banner-title */}
              <h3 className="banner-subtitle text-brightblack">IN THIS LOOK</h3>{/* End .banner-subtitle */}
              <ul className="text-white">
                <li>Moto Jacket</li>
                <li>Henry Backpack</li>
              </ul>
              <div className="banner-text text-brightblack">$98.00 - $1,298.00</div>{/* End .banner-text */}
              <a href="#" className="btn btn-outline-primary-2"><span>Buy All</span><i className="icon-long-arrow-right" /></a>
            </div>{/* End .banner-content */}
          </div>{/* End .banner */}
        </div>{/* End .col-lg-6 */}
        <div className="col-lg-6">
          <div className="heading text-center">
            <h2 className="title">About This Look</h2>{/* End .title text-center */}
            <p className="title-desc">Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Donec odio. Quisque volutpat mattis eros. Nullam malesuada erat ut turpis.</p>{/* End .title-desc */}
          </div>{/* End .heading */}
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <div className="row">
                <div className="col-6">
                  <div className="product product-4">
                    <figure className="product-media">
                      <a href="product.html">
                        <img src="asset/images/demos/demo-15/products/product-1.jpg" alt="Product image" className="product-image" />
                      </a>
                      <div className="product-action-vertical">
                        <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                        <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                        <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                      </div>{/* End .product-action */}
                      <div className="product-action">
                        <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                      </div>{/* End .product-action */}
                    </figure>{/* End .product-media */}
                    <div className="product-body">
                      <h3 className="product-title"><a href="product.html">Suede Moto Jacket</a></h3>{/* End .product-title */}
                      <div className="product-price">
                        <span className="new-price">Now $1,298.00</span>
                        <span className="old-price">Was $1,400.00</span>
                      </div>{/* End .product-price */}
                    </div>{/* End .product-body */}
                  </div>{/* End .product */}
                </div>{/* End .col-sm-6 */}
                <div className="col-6">
                  <div className="product product-4">
                    <figure className="product-media">
                      <a href="product.html">
                        <img src="asset/images/demos/demo-15/products/product-2.jpg" alt="Product image" className="product-image" />
                      </a>
                      <div className="product-action-vertical">
                        <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                        <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                        <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                      </div>{/* End .product-action */}
                      <div className="product-action">
                        <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                      </div>{/* End .product-action */}
                    </figure>{/* End .product-media */}
                    <div className="product-body">
                      <h3 className="product-title"><a href="product.html">Henry Leather Backpack</a></h3>{/* End .product-title */}
                      <div className="product-price">
                        $448.00
                      </div>{/* End .product-price */}
                      <div className="product-nav product-nav-dots">
                        <a href="#" className="active" style={{background: '#917f4d'}}><span className="sr-only">Color name</span></a>
                        <a href="#" style={{background: '#c55858'}}><span className="sr-only">Color name</span></a>
                      </div>{/* End .product-nav */}
                    </div>{/* End .product-body */}
                  </div>{/* End .product */}
                </div>{/* End .col-sm-6 */}
              </div>{/* End .row */}
            </div>{/* End .col-lg-8 offset-lg-2 */}
          </div>{/* End .row */}
        </div>{/* End .col-lg-6 */}
      </div>{/* End .row */}
    </div>{/* End .container-fluid */}
  </div>{/* End .display-row */}
  <div className="display-row" style={{backgroundColor: '#f2f2f2'}}>
    <div className="container-fluid">
      <div className="row align-items-center">
        <div className="col-lg-6">
          <div className="banner banner-light banner-overlay">
            <a href="#">
              <img src="asset/images/demos/demo-15/banners/banner-2.jpg" alt="Banner" />
            </a>
            <div className="banner-content women">
              <h2 className="banner-title">02. Dresses for <br />every spring day.</h2>{/* End .banner-title */}
              <h3 className="banner-subtitle text-darkblack">IN THIS LOOK</h3>{/* End .banner-subtitle */}
              <ul>
                <li>Light grey linen shirt dress</li>
                <li>Gold colour earrings</li>
                <li>Brown heel mules</li>
              </ul>
              <div className="banner-text text-darkblack">$20.00 - $96.00</div>{/* End .banner-text */}
              <a href="#" className="btn btn-outline-primary-2"><span>Buy All</span><i className="icon-long-arrow-right" /></a>
            </div>{/* End .banner-content */}
          </div>{/* End .banner */}
        </div>{/* End .col-lg-6 */}
        <div className="col-lg-6">
          <div className="heading text-center">
            <h2 className="title">About This Look</h2>{/* End .title text-center */}
            <p className="title-desc">Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Donec odio. Quisque volutpat mattis eros. Nullam malesuada erat ut turpis.</p>{/* End .title-desc */}
          </div>{/* End .heading */}
          <div className="row">
            <div className="col-6 col-md-4">
              <div className="product product-4">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-15/products/product-3.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-15/products/product-3-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                    <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                    <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                  </div>{/* End .product-action */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  </div>{/* End .product-action */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Light grey linen shirt dress</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $92.00
                  </div>{/* End .product-price */}
                </div>{/* End .product-body */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 */}
            <div className="col-6 col-md-4">
              <div className="product product-4">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-15/products/product-4.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-15/products/product-4-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                    <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                    <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                  </div>{/* End .product-action */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  </div>{/* End .product-action */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Gold colour textured doorknocker earrings</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $20.00
                  </div>{/* End .product-price */}
                </div>{/* End .product-body */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 */}
            <div className="col-6 col-md-4">
              <div className="product product-4">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-15/products/product-5.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-15/products/product-5-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                    <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                    <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                  </div>{/* End .product-action */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  </div>{/* End .product-action */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Gold colour textured doorknocker</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $96.00
                  </div>{/* End .product-price */}
                  <div className="product-nav product-nav-dots">
                    <a href="#" className="active" style={{background: '#99523e'}}><span className="sr-only">Color name</span></a>
                    <a href="#" style={{background: '#333333'}}><span className="sr-only">Color name</span></a>
                  </div>{/* End .product-nav */}
                </div>{/* End .product-body */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 */}
          </div>{/* End .row */}
        </div>{/* End .col-lg-6 */}
      </div>{/* End .row */}
    </div>{/* End .container-fluid */}
  </div>{/* End .display-row .bg-light */}
  <div className="video-banner video-banner-bg video-fullheight bg-image text-center" style={{backgroundImage: 'url(asset/images/demos/demo-15/bg-1.jpg)'}}>
    <div className="container">
      <h3 className="video-banner-title h1 text-white"><span>Spring / Summer</span>The New Romantic Collection 2019</h3>{/* End .video-banner-title */}
      <a href="https://www.youtube.com/watch?v=vBPgmASQ1A0" className="btn-video btn-iframe"><i className="icon-play" /></a>
    </div>{/* End .container */}
  </div>{/* End .video-banner bg-image */}
  <div className="display-row bg-light">
    <div className="container-fluid">
      <div className="row align-items-center">
        <div className="col-lg-6 order-lg-last">
          <div className="banner banner-overlay">
            <a href="#">
              <img src="asset/images/demos/demo-15/banners/banner-3.jpg" alt="Banner" />
            </a>
            <div className="banner-content men">
              <h2 className="banner-title text-white">03. Beautiful <br />dresses perfect <br />for any occasion.</h2>{/* End .banner-title */}
              <h3 className="banner-subtitle text-brightblack">IN THIS LOOK</h3>{/* End .banner-subtitle */}
              <ul className="text-white">
                <li>Botanical-Print Dress</li>
                <li>Cece Shoulder Bag</li>
                <li>Cunningham Leather Sandal</li>
              </ul>
              <div className="banner-text text-brightblack">$130.00 - $358.00</div>{/* End .banner-text */}
              <a href="#" className="btn btn-outline-primary-2"><span>Buy All</span><i className="icon-long-arrow-right" /></a>
            </div>{/* End .banner-content */}
          </div>{/* End .banner */}
        </div>{/* End .col-lg-6 */}
        <div className="col-lg-6">
          <div className="heading text-center">
            <h2 className="title">About This Look</h2>{/* End .title text-center */}
            <p className="title-desc">Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Donec odio. Quisque volutpat mattis eros. Nullam malesuada erat ut turpis.</p>{/* End .title-desc */}
          </div>{/* End .heading */}
          <div className="row">
            <div className="col-6 col-md-4">
              <div className="product product-4">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-15/products/product-6.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-15/products/product-6-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                    <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                    <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                  </div>{/* End .product-action */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  </div>{/* End .product-action */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Botanical-Print Crepe Dress</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $165.00
                  </div>{/* End .product-price */}
                </div>{/* End .product-body */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 */}
            <div className="col-6 col-md-4">
              <div className="product product-4">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-15/products/product-7.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-15/products/product-7-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                    <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                    <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                  </div>{/* End .product-action */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  </div>{/* End .product-action */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Cunningham Leather Sandal</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $130.00
                  </div>{/* End .product-price */}
                </div>{/* End .product-body */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 */}
            <div className="col-6 col-md-4">
              <div className="product product-4">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-15/products/product-8.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-15/products/product-8-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                    <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                    <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                  </div>{/* End .product-action */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  </div>{/* End .product-action */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Cece Medium Leather Shoulder Bag</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $358.00
                  </div>{/* End .product-price */}
                  <div className="product-nav product-nav-dots">
                    <a href="#" className="active" style={{background: '#333'}}><span className="sr-only">Color name</span></a>
                    <a href="#" style={{background: '#c55858'}}><span className="sr-only">Color name</span></a>
                  </div>{/* End .product-nav */}
                </div>{/* End .product-body */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 */}
          </div>{/* End .row */}
        </div>{/* End .col-lg-6 */}
      </div>{/* End .row */}
    </div>{/* End .container-fluid */}
  </div>{/* End .display-row .bg-light */}
  <div className="display-row">
    <div className="container-fluid">
      <div className="row align-items-center">
        <div className="col-lg-6">
          <div className="banner banner-light banner-overlay">
            <a href="#">
              <img src="asset/images/demos/demo-15/banners/banner-4.jpg" alt="Banner" />
            </a>
            <div className="banner-content women">
              <h2 className="banner-title">04. Complete your <br />look with the latest <br />accessories.</h2>{/* End .banner-title */}
              <h3 className="banner-subtitle text-darkblack">IN THIS LOOK</h3>{/* End .banner-subtitle */}
              <ul>
                <li>Black mini boxy cross body bag</li>
                <li>Black zebra print leather heel mules</li>
              </ul>
              <div className="banner-text text-darkblack">$36.00 - $120.00</div>{/* End .banner-text */}
              <a href="#" className="btn btn-outline-primary-2"><span>Buy All</span><i className="icon-long-arrow-right" /></a>
            </div>{/* End .banner-content */}
          </div>{/* End .banner */}
        </div>{/* End .col-lg-6 */}
        <div className="col-lg-6">
          <div className="heading text-center">
            <h2 className="title">About This Look</h2>{/* End .title text-center */}
            <p className="title-desc">Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Donec odio. Quisque volutpat mattis eros. Nullam malesuada erat ut turpis.</p>{/* End .title-desc */}
          </div>{/* End .heading */}
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <div className="row">
                <div className="col-6">
                  <div className="product product-4">
                    <figure className="product-media">
                      <a href="product.html">
                        <img src="asset/images/demos/demo-15/products/product-9.jpg" alt="Product image" className="product-image" />
                        <img src="asset/images/demos/demo-15/products/product-9-2.jpg" alt="Product image" className="product-image-hover" />
                      </a>
                      <div className="product-action-vertical">
                        <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                        <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                        <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                      </div>{/* End .product-action */}
                      <div className="product-action">
                        <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                      </div>{/* End .product-action */}
                    </figure>{/* End .product-media */}
                    <div className="product-body">
                      <h3 className="product-title"><a href="product.html">Black zebra print leather heel mules</a></h3>{/* End .product-title */}
                      <div className="product-price">
                        $120.00
                      </div>{/* End .product-price */}
                    </div>{/* End .product-body */}
                  </div>{/* End .product */}
                </div>{/* End .col-sm-6 */}
                <div className="col-6">
                  <div className="product product-4">
                    <figure className="product-media">
                      <a href="product.html">
                        <img src="asset/images/demos/demo-15/products/product-10.jpg" alt="Product image" className="product-image" />
                        <img src="asset/images/demos/demo-15/products/product-10-2.jpg" alt="Product image" className="product-image-hover" />
                      </a>
                      <div className="product-action-vertical">
                        <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                        <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                        <a href="#" className="btn-product-icon btn-compare" title="Compare"><span>Compare</span></a>
                      </div>{/* End .product-action */}
                      <div className="product-action">
                        <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                      </div>{/* End .product-action */}
                    </figure>{/* End .product-media */}
                    <div className="product-body">
                      <h3 className="product-title"><a href="product.html">Black mini boxy cross body bag</a></h3>{/* End .product-title */}
                      <div className="product-price">
                        $36.00
                      </div>{/* End .product-price */}
                    </div>{/* End .product-body */}
                  </div>{/* End .product */}
                </div>{/* End .col-sm-6 */}
              </div>{/* End .row */}
            </div>{/* End .col-lg-8 offset-lg-2 */}
          </div>{/* End .row */}
        </div>{/* End .col-lg-6 */}
      </div>{/* End .row */}
    </div>{/* End .container-fluid */}
  </div>{/* End .display-row */}
  <div className="mb-2" />{/* End .mb-2 */}
  <div className="container-fluid">
    <div className="cta cta-separator">
      <div className="row">
        <div className="col-lg-6">
          <div className="cta-wrapper cta-text text-center">
            <h3 className="cta-title">Shop Social</h3>{/* End .cta-title */}
            <p className="cta-desc">Donec nec justo eget felis facilisis fermentum. Aliquam porttitor mauris sit amet orci. </p>{/* End .cta-desc */}
            <div className="social-icons social-icons-colored justify-content-center">
              <a href="#" className="social-icon social-facebook" title="Facebook" target="_blank"><i className="icon-facebook-f" /></a>
              <a href="#" className="social-icon social-twitter" title="Twitter" target="_blank"><i className="icon-twitter" /></a>
              <a href="#" className="social-icon social-instagram" title="Instagram" target="_blank"><i className="icon-instagram" /></a>
              <a href="#" className="social-icon social-youtube" title="Youtube" target="_blank"><i className="icon-youtube" /></a>
              <a href="#" className="social-icon social-pinterest" title="Pinterest" target="_blank"><i className="icon-pinterest" /></a>
            </div>{/* End .soial-icons */}
          </div>{/* End .cta-wrapper */}
        </div>{/* End .col-lg-6 */}
        <div className="col-lg-6">
          <div className="cta-wrapper text-center">
            <h3 className="cta-title mb-2">Our Costumers Say</h3>{/* End .cta-title */}
            <div className="owl-carousel owl-simple owl-testimonials" data-toggle="owl" data-owl-options="{
                      &quot;nav&quot;: false, 
                      &quot;dots&quot;: true,
                      &quot;margin&quot;: 20,
                      &quot;loop&quot;: true,
                      &quot;responsive&quot;: {
                          &quot;1500&quot;: {
                              &quot;nav&quot;: true
                          }
                      }
                  }">
              <blockquote className="testimonial testimonial-icon text-center">
                <p>“ Donec nec justo eget felis facilisis fermentum. Aliquam porttitor mauris sit amet orci. Aenean dignissim pellentesque felis. ”</p>
                <cite>
                  Charly Smith,
                  <span>Customer</span>
                </cite>
              </blockquote>{/* End .testimonial */}
              <blockquote className="testimonial testimonial-icon text-center">
                <p>“ Impedit, ratione sequi, sunt incidunt magnam et. Delectus obcaecati optio eius error libero perferendis nesciunt atque. ”</p>
                <cite>
                  Damon Stone
                  <span>Customer</span>
                </cite>
              </blockquote>{/* End .testimonial */}
              <blockquote className="testimonial testimonial-icon text-center">
                <p>“ Perferendis perspiciatis, voluptate, distinctio earum veritatis animi tempora eget blandit nunc tortor eu nibh. ”</p>
                <cite>
                  John Smith
                  <span>Customer</span>
                </cite>
              </blockquote>{/* End .testimonial */}
            </div>{/* End .testimonials-slider owl-carousel */}
          </div>{/* End .cta-wrapper */}
        </div>{/* End .col-lg-6 */}
      </div>{/* End .row */}
    </div>{/* End .cta */}
  </div>{/* End .container-fluid */}
  <div className="mb-7" />{/* End .mb-7 */}
  <div className="blog-posts mb-9">
    <div className="container-fluid">
      <div className="heading text-center">
        <h2 className="title">From Our Blog</h2>{/* End .title text-center */}
        <p className="title-desc">Donec odio. Quisque volutpat mattis eros. <br />Nullam malesuada erat</p>{/* End .title-desc */}
      </div>{/* End .heading */}
      <div className="owl-carousel owl-simple" data-toggle="owl" data-owl-options="{
          &quot;nav&quot;: false, 
          &quot;dots&quot;: true,
          &quot;items&quot;: 3,
          &quot;margin&quot;: 20,
          &quot;loop&quot;: false,
          &quot;responsive&quot;: {
              &quot;0&quot;: {
                  &quot;items&quot;:1
              },
              &quot;520&quot;: {
                  &quot;items&quot;:2
              },
              &quot;768&quot;: {
                  &quot;items&quot;:3
              },
              &quot;992&quot;: {
                  &quot;items&quot;:4
              }
          }
      }">
        <article className="entry">
          <figure className="entry-media">
            <a href="single.html">
              <img src="asset/images/demos/demo-15/blog/post-1.jpg" alt="image desc" />
            </a>
          </figure>{/* End .entry-media */}
          <div className="entry-body text-center">
            <div className="entry-meta">
              <a href="#">Nov 22, 2018</a>, 1 Comments
            </div>{/* End .entry-meta */}
            <h3 className="entry-title">
              <a href="single.html">Sed adipiscing ornare.</a>
            </h3>{/* End .entry-title */}
            <div className="entry-content">
              <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Donec odio. Quisque volutpat mattis eros. </p>
              <a href="single.html" className="read-more">Read More</a>
            </div>{/* End .entry-content */}
          </div>{/* End .entry-body */}
        </article>{/* End .entry */}
        <article className="entry">
          <figure className="entry-media">
            <a href="single.html">
              <img src="asset/images/demos/demo-15/blog/post-2.jpg" alt="image desc" />
            </a>
          </figure>{/* End .entry-media */}
          <div className="entry-body text-center">
            <div className="entry-meta">
              <a href="#">Dec 12, 2018</a>, 0 Comments
            </div>{/* End .entry-meta */}
            <h3 className="entry-title">
              <a href="single.html">Fusce lacinia arcuet nulla.</a>
            </h3>{/* End .entry-title */}
            <div className="entry-content">
              <p>Donec odio. Quisque volutpat mattis eros. Nullam malesuada erat ut turpis. Suspendisse urnanib ... </p>
              <a href="single.html" className="read-more">Read More</a>
            </div>{/* End .entry-content */}
          </div>{/* End .entry-body */}
        </article>{/* End .entry */}
        <article className="entry">
          <figure className="entry-media">
            <a href="single.html">
              <img src="asset/images/demos/demo-15/blog/post-3.jpg" alt="image desc" />
            </a>
          </figure>{/* End .entry-media */}
          <div className="entry-body text-center">
            <div className="entry-meta">
              <a href="#">Dec 19, 2018</a>, 2 Comments
            </div>{/* End .entry-meta */}
            <h3 className="entry-title">
              <a href="single.html">Quisque volutpat mattis eros.</a>
            </h3>{/* End .entry-title */}
            <div className="entry-content">
              <p>Quisque volutpat mattis eros. Nullam malesuada eratut turpis. Suspendisse urna nibh, viverra non ...</p>
              <a href="single.html" className="read-more">Read More</a>
            </div>{/* End .entry-content */}
          </div>{/* End .entry-body */}
        </article>{/* End .entry */}
        <article className="entry">
          <figure className="entry-media">
            <a href="single.html">
              <img src="asset/images/demos/demo-15/blog/post-4.jpg" alt="image desc" />
            </a>
          </figure>{/* End .entry-media */}
          <div className="entry-body text-center">
            <div className="entry-meta">
              <a href="#">Dec 25, 2018</a>, 3 Comments
            </div>{/* End .entry-meta */}
            <h3 className="entry-title">
              <a href="single.html">Mauris suscipit in massa.</a>
            </h3>{/* End .entry-title */}
            <div className="entry-content">
              <p>Nullam malesuada eratut turpis. Suspendisse urna nibh, viverra non, semper suscipit, posuere a, pede.</p>
              <a href="single.html" className="read-more">Read More</a>
            </div>{/* End .entry-content */}
          </div>{/* End .entry-body */}
        </article>{/* End .entry */}
      </div>{/* End .owl-carousel */}
    </div>{/* End .container-fluid */}
  </div>{/* End .blog-posts */}
</main>

        <UserFooter/>

    </div>
  )
}

export default Index15